module.exports = __webpack_public_path__ + "img/discuss-screen-en.7419b9b3.webp";